/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesNativePlatformFromJSON, FxIdDomainEntitiesNativePlatformToJSON, } from './FxIdDomainEntitiesNativePlatform';
import { FxIdDomainAnalyticsTsAnalyticsEventFromJSON, FxIdDomainAnalyticsTsAnalyticsEventToJSON, } from './FxIdDomainAnalyticsTsAnalyticsEvent';
/**
 * Check if a given object implements the FxIdWebFeaturesAnalyticsTrackRequest interface.
 */
export function instanceOfFxIdWebFeaturesAnalyticsTrackRequest(value) {
    if (!('Platform' in value) || value['Platform'] === undefined)
        return false;
    if (!('BuildId' in value) || value['BuildId'] === undefined)
        return false;
    if (!('Events' in value) || value['Events'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAnalyticsTrackRequestFromJSON(json) {
    return FxIdWebFeaturesAnalyticsTrackRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAnalyticsTrackRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SessionId': json['SessionId'] == null ? undefined : json['SessionId'],
        'Platform': FxIdDomainEntitiesNativePlatformFromJSON(json['Platform']),
        'BuildId': json['BuildId'],
        'Events': (json['Events'].map(FxIdDomainAnalyticsTsAnalyticsEventFromJSON)),
    };
}
export function FxIdWebFeaturesAnalyticsTrackRequestToJSON(json) {
    return FxIdWebFeaturesAnalyticsTrackRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAnalyticsTrackRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SessionId': value['SessionId'],
        'Platform': FxIdDomainEntitiesNativePlatformToJSON(value['Platform']),
        'BuildId': value['BuildId'],
        'Events': (value['Events'].map(FxIdDomainAnalyticsTsAnalyticsEventToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAnalyticsTrackRequest.js.map